export const toastAutoClose = 3000;